<template>
  <v-form ref="addPlanForm"
          :disabled="isFormDisabled()"
  >
    <v-row>
      <v-col cols="12" sm="6" md="4" xl="3">
        <v-text-field
            v-model="details.order"
            label="Lp"
            hint="Liczba porządkowa - uwzględniana przy sortowaniu."
            persistent-hint
            :aria-required="true"
        />
      </v-col>
      <v-col cols="12" sm="6" md="8" xl="3">
        <v-text-field
            v-model="details.name"
            label="Nazwa"
            :aria-required="true"
            :counter="30"
        />
      </v-col>
      <v-col cols="12" sm="6" lg="4" xl="2">
        <v-text-field
            v-model="details.priceInPln"
            label="Cena za miesiąc"
            hint="Kwota w groszach!"
            persistent-hint
            :aria-required="true"
            disabled
        >
          <template slot="append-outer">
            <span style="white-space: nowrap">
              {{ formatAmount(details.priceInPln) }} PLN
            </span>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" lg="4" xl="4">
        <v-text-field
            v-model="details.yearlyPriceInPln"
            label="Cena za miesiąc (promocyjna)"
            hint="Kwota w groszach! Dotyczy subskrypcji rocznej."
            persistent-hint
            :aria-required="true"
            disabled
        >
          <template slot="append-outer">
            <span style="white-space: nowrap">
              {{ formatAmount(details.yearlyPriceInPln) }} PLN
            </span>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4">
        <div class="pb-0 disabled-label">
          Dostępny:
        </div>
        <v-switch
            :v-model="mapBool(details.available, true)"
            :input-value="mapBool(details.available, true)"
            :value="true"
            class="mt-0 pt-0"
            :label="false !== details.available ? 'Tak' : 'Nie'"
            hint="Określa, czy plan może być wyświetlany i kupowany."
            persistent-hint
            @change="onAvailabilitySwitched"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn
            :disabled="saving"
            @click="save"
            v-if="isIdle()"
        >
          Zapisz
          <v-icon size="24" right>
            mdi-content-save-outline
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <modal-loader :show="loading"/>
  </v-form>
</template>

<script>
import api from "@/services/api";
import ModalLoader from "@/components/ModalLoader";
import formatters from "@/mixins/formatters";

export default {
  props: {
    id: {
      type: [String],
      required: false,
      default: null,
    },
  },
  mixins: [
    formatters,
  ],
  components: {
    ModalLoader,
  },
  data() {
    return {
      default: {
        order: 0,
        available: false,
        priceInPln: null,
        yearlyPriceInPln: null,
        name: '',
        availableFrom: null,
        availableTo: null,
      },
      details: {
        order: 0,
        available: false,
        priceInPln: null,
        yearlyPriceInPln: null,
        name: '',
        availableFrom: null,
        availableTo: null,
      },
      label: {},
      rules: {},
      loading: false,
      saving: false,
    };
  },
  computed: {},
  created() {
    if (this.id) {
      this.get();
    }
  },
  methods: {
    isIdle() {
      return !this.loading && !this.saving;
    },
    isFormDisabled() {
      return !this.isIdle();
    },
    isEditForm() {
      return !!this.id;
    },
    add() {

    },
    get() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      api.get(`/api/subscription/plan/${this.id}`)
          .then((response) => {
            this.details = response.data;
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się pobrać danych planu.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    mapBool(value, onNull = false) {
      if (null === value) {
        return onNull;
      }

      return !!value;
    },
    save() {
      if (this.saving) {
        return;
      }

      if (this.isEditForm()) {
        this.update();
      } else {
        this.add();
      }
    },
    update() {
      if (this.saving) {
        return;
      }

      this.saving = true;
      const self = this;
      let details = {
        order: this.details.order,
        available: this.details.available,
        name: this.details.name,
      };

      delete details.id;

      api.put(`/api/subscription/plan/${this.id}`, details)
          .then((response) => {
            this.details = response.data;
            this.$root.$emit('notifySuccess', {
              html: 'Plan został zapisany.',
              callback: () => {
                // The following setTimeout() call is required to render the success message for the user before
                // displaying the built-in prompt window.
                setTimeout(function () {
                  self.saving = false;
                }, 500);
              }
            });
          })
          .catch((error) => {
            this.saving = false;
            this.$root.$emit('notifyError', {
              html: 'Nie udało się zaktualizować danych planu.',
              error,
            });
          });
    },
    askForNextCompany() {
      if (confirm('Chcesz dodać kolejny plan?')) {
        this.clear();
      } else {
        this.$router
            .push({name: 'subscription-plans'})
            .catch(() => {
            });
      }
    },
    clear() {
      this.details.order = this.default.order;
      this.details.available = false;
      this.details.priceInPln = 0;
      this.details.yearlyPriceInPln = 0;
      this.details.name = this.default.name;
      this.details.availableFrom = this.default.availableFrom;
      this.details.availableTo = this.default.availableTo;
    },
    onAvailabilitySwitched(newValue) {
      this.details.available = !!newValue;
    },
  },
}
</script>